(ns practitest.frontend.components2.dashboard.charts.marks-gen
  (:require ["d3" :as d3]))

(defn- accessor [{:keys [field]}]
  (fn [d] (aget d (name field))))

(defn project-x [{{:keys [x]} :encode}]
  (let [getter (accessor x)
        scale  (:d3-scale x)]
    (fn [d] (scale (getter d)))))

(defn project-y [{{:keys [y]} :encode}]
  (let [getter (accessor y)
        scale  (:d3-scale y)]
    (fn [d] (scale (getter d)))))

(defn line [ctx]
  (-> (.line d3)
      (.x (project-x ctx))
      (.y (project-y ctx))))

(defn area [x-mid y-scale]
  (-> (.area d3)
      (.x x-mid)
      (.y0 (fn [^js d] (y-scale (aget d 0))))
      (.y1 (fn [^js d] (y-scale (aget d 1))))))

(defn area-flat [x-mid baseline-y]
  (-> (.area d3)
      (.x x-mid)
      (.y0 (fn [_] baseline-y))
      (.y1 (fn [_] baseline-y))))

(defn pie-arcs
  [data theta-field]
  (let [layout (-> (.pie d3)
                   (.value (fn [^js d] (aget d (name theta-field))))
                   (.sort nil))]
    (layout (clj->js data))))

(defn- min-angle-spans
  "Angular span per value: every slice gets at least min-angle, the rest of the
   circle is shared proportionally. Iterates because shrinking the others can
   push another slice below the minimum."
  [values min-angle]
  (let [full      (* 2 js/Math.PI)
        n         (count values)
        min-angle (min min-angle (/ full n))]
    (loop [pinned #{}]
      (let [free      (remove pinned (range n))
            free-sum  (reduce + (map values free))
            budget    (- full (* min-angle (count pinned)))
            span      (fn [i] (if (pinned i) min-angle (* budget (/ (values i) free-sum))))
            too-small (filter #(< (span %) min-angle) free)]
        (if (empty? too-small)
          (mapv span (range n))
          (recur (into pinned too-small)))))))

(defn enforce-min-angle
  "Rewrites start/end angles of d3 pie arcs (in place) so no slice is narrower
   than min-angle radians."
  [^js arcs min-angle]
  (let [spans (min-angle-spans (mapv (fn [^js d] (.-value d)) arcs) min-angle)]
    (reduce (fn [start [^js d span]]
              (set! (.-startAngle d) start)
              (set! (.-endAngle d) (+ start span))
              (+ start span))
            0
            (map vector arcs spans))
    arcs))
